module.exports = __webpack_public_path__ + "media/images/promo/custom-collective-tile-cd09b7c04655e70e38b00d76d1771254.jpg";